import InviteUser from './InviteUser';

export default InviteUser;
